module.exports = __webpack_public_path__ + "static/media/Gibson-SemiBold.5436eb62.otf";